import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import VerticalScrapShear from './verticalscrapshear';


// Breadcrumbs Background Image

const VerticalheavyScrapShear = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <Header
                navImg={navImg1}
                parentMenu='peak-performance-roofing'
                activeMenu="/peak-performance-roofing"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Vertical Heavy Duty Scrap Shear"
                pageName="Vertical Heavy Duty Scrap Shear"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <VerticalScrapShear />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default VerticalheavyScrapShear;